import React from "react";
import s from "./Catalogue.module.scss";
import CarItem from "../CarItem/CarItem";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCarsByCategory } from "../../redux/carSlice";

const Catalogue = ({ title, cars, categoryId }) => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();

  return (
    <div>
      {cars.length > 0 ? (
        <div className={s.header_links}>
          <Link
            to={`/category/${categoryId}`}
            className={s.title}
            onClick={() => dispatch(getCarsByCategory(categoryId))}
          >
            {title}
          </Link>
          <Link
            to={`/category/${categoryId}`}
            className={s.title2}
            onClick={() => dispatch(getCarsByCategory(categoryId))}
          >
            {title === "Спецтехника" ? "Вся" : "Все"} {title?.toLowerCase()} (
            {cars?.length})
          </Link>
        </div>
      ) : null}
      <div className={s.catalogue}>
        {Array.isArray(cars) &&
          cars.length > 0 &&
          cars?.map((it, index) => (
            <Link to={`/car/${it?.id}`} key={index}>
              <CarItem car={it} key={it.id} />
            </Link>
          ))}
      </div>
    </div>
  );
};
export default Catalogue;
